/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const BillSplit = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M23 1V23L19 21L15.5 23L12 21L8 23L7.99971 13.789L9.49971 12.923L9.5 20.573L12.0472 19.2993L15.499 21.272L18.9528 19.2993L21.5 20.573V12.75H19.5V11.25H21.5V2.5H9.5L9.49971 7.726L7.99971 8.592L8 1H23ZM6.89852 5.32162C7.25786 6.66267 6.64921 8.03505 5.50088 8.69693L8.159 10.2303L14.8748 6.3506L15.6252 7.6494L9.499 11.188L7.99971 12.057L5.49988 13.4986C6.64886 14.1603 7.25796 15.5331 6.89852 16.8745C6.4697 18.4749 4.82469 19.4247 3.22429 18.9959C1.62389 18.567 0.674142 16.922 1.10297 15.3216C1.31738 14.5214 1.83584 13.8839 2.50074 13.5L6.659 11.0963L2.50074 8.69615L2.36056 8.61004C1.76332 8.22036 1.30206 7.61758 1.10297 6.87453C0.674142 5.27413 1.62389 3.62912 3.22429 3.2003C4.82469 2.77147 6.4697 3.72122 6.89852 5.32162ZM2.55186 15.7098C2.33744 16.51 2.81232 17.3326 3.61252 17.547C4.41271 17.7614 5.23522 17.2865 5.44963 16.4863C5.66405 15.6861 5.18917 14.8636 4.38897 14.6492C3.58877 14.4348 2.76627 14.9096 2.55186 15.7098ZM14.5 11.25V12.75H12.5V11.25H14.5ZM18 11.25V12.75H16V11.25H18ZM3.61252 4.64919C2.81232 4.8636 2.33744 5.68611 2.55186 6.4863C2.76627 7.2865 3.58877 7.76138 4.38897 7.54697C5.18917 7.33255 5.66405 6.51005 5.44963 5.70985C5.23522 4.90965 4.41271 4.43477 3.61252 4.64919Z"
                        fill={color}
                    />
                </svg>
        );
    };
